import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBold = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 640 640",
		fill: "currentColor",
		...props,
		children: /* @__PURE__ */ _jsx("path", { d: "M152 96C138.7 96 128 106.7 128 120C128 133.3 138.7 144 152 144L192 144L192 496L152 496C138.7 496 128 506.7 128 520C128 533.3 138.7 544 152 544L388 544C456.5 544 512 488.5 512 420C512 371.1 483.7 328.9 442.7 308.7C465.7 286.2 480 254.8 480 220C480 151.5 424.5 96 356 96L152 96zM432 220C432 262 398 296 356 296L240 296L240 144L356 144C398 144 432 178 432 220zM240 496L240 344L388 344C430 344 464 378 464 420C464 462 430 496 388 496L240 496z" })
	});
};
export default SvgBold;
